module.exports = __webpack_public_path__ + "img/94ne.a02a5b76.svg";